<template>
  <button class="button"
          :class="[theme,size]"
          type="submit"
          :disabled="disabled || loading"
          @click.prevent="$emit('click')">
    <slot v-if="!loading"></slot>
    <font-awesome-icon v-else icon="circle-notch" spin/>
  </button>
</template>

<script>
export default {
  name: "BaseButton",
  props: {
    theme: {
      type: String,
      default: null,
      validator: (val) => [
        'default',
        'gray',
        'red',
        'red-outline',
        'yellow',
        'green',
        'remove',
        'white',
        'white-bordered',
        'white-red',
        'gray'
      ].includes(val)
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
      validator: (val) => ['xs', 'sm', 'md'].includes(val)
    },
    loading: {
      type: Boolean,
    }
  }
}
</script>

<style scoped lang="scss">
.button {
  @apply h-16 text-center rounded px-8
  font-bold text-white text-md
  transition duration-200 outline-none cursor-pointer;
  &.sm {
    @apply h-12 px-5;
  }

  &.xs {
    @apply h-10-5 px-6 text-2sm;
  }

  &:active {
    box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.1);
  }

  &.remove {
    @apply border border-border text-text font-normal;
    &:hover {
      @apply bg-red border-red text-white;
    }

    &[disabled] {
      @apply opacity-75;
    }
  }

  &.default {
    @apply border border-border text-text-label bg-block;
    svg {
      @apply text-icon;
      transition: all .2s;
    }

    &:hover {
      @apply border-border-hover;
      svg {
        @apply text-icon-hover;
      }
    }

    &[disabled] {
      @apply opacity-75 border border-border;
      svg {
        @apply text-icon;
      }
    }
  }

  &.blue {
    @apply bg-bg-contractor shadow-darkBlue;
    &:hover,
    &:focus {
      @apply shadow-darkBlueHover;
      background-color: #4A80A4;
    }
  }

  &.green {
    @apply bg-green shadow-green;

    &:hover,
    &:focus {
      @apply bg-green-hover shadow-greenHover;
    }

    &[disabled] {
      @apply bg-green-light;
    }
  }

  &.red {
    @apply bg-red shadow-red;

    &:hover,
    &:focus {
      @apply bg-red-hover shadow-redHover;
    }

    &[disabled] {
      @apply bg-red-light;
    }
  }

  &.red-outline {
    @apply flex items-center px-6 text-text font-normal
    border border-red h-12 rounded bg-block transition duration-200;
    &:hover {
      @apply bg-red text-white;
    }
  }

  &.yellow {
    @apply bg-yellow shadow-yellow;

    &:hover,
    &:focus {
      @apply bg-yellow-hover shadow-yellowHover;
    }

    &[disabled] {
      @apply bg-yellow-light;
    }
  }

  &.white {
    @apply bg-block shadow-primaryBlock text-text-ternary;

    &:hover,
    &:focus {
      @apply bg-gray-hover shadow-grayHover text-white;
    }

    &[disabled] {
      @apply opacity-50;
    }
  }

  &.white-bordered {
    @apply bg-block border border-border text-text-label;
    &:hover {
      @apply text-text border-border-hover;
    }
  }

  &.white-red {
    @apply bg-block border border-border text-text-label font-normal;
    &:hover {
      @apply border-red-hover bg-red-hover shadow-redHover text-white;
    }
  }

  &.gray {
    @apply bg-gray shadow-gray;

    &:hover,
    &:focus {
      @apply bg-gray-hover shadow-grayHover;
    }

    &[disabled] {
      @apply bg-gray-light;
    }
  }

  &.red, &.yellow, &.green, &.gray, &.white {
    &:active {
      box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
